import { Entity } from "@/app/types"
import { Button } from "@/components/buttons/button"
import { handleOpenNewTab } from "@/components/entity/entity.selector_functions"
import { ArrowSquareOut, DotsThree } from "@phosphor-icons/react"
import { useMemo, useState } from "react"
import Popup from "reactjs-popup"

type ButtonOverviewProps = {
  entity: Entity
}

export function ButtonOverview({ entity }: ButtonOverviewProps) {
  const [isOpen, setOpen] = useState<boolean>(false)
  const closePopup = () => setOpen(false)
  const openPopup = () => setOpen(true)

  function getPopupOptions() {
    if (entity.isFund())
      return [
        {
          text: (
            <div className="flex items-center gap-1">
              Fund Overview
              <ArrowSquareOut />
            </div>
          ),
          onClick: () => {
            handleOpenNewTab(true, entity.getId())
            closePopup()
          },
        },
        {
          text: (
            <div className="flex items-center gap-1">
              Firm Overview
              <ArrowSquareOut />
            </div>
          ),
          onClick: () => {
            handleOpenNewTab(false, entity.getFund().firmId)
            closePopup()
          },
        },
      ]
    else
      return [
        {
          text: (
            <div className="flex items-center gap-1">
              Firm Overview
              <ArrowSquareOut />
            </div>
          ),
          onClick: () => {
            handleOpenNewTab(false, entity.getId())
            closePopup()
          },
        },
      ]
  }

  const popupOptions = useMemo(() => {
    return getPopupOptions()
  }, [entity])

  return (
    <Button color="primary" className="print:hidden" onClick={openPopup}>
      <div className="flex place-content-center">
        {popupOptions && (
          <Popup
            open={isOpen}
            onOpen={openPopup}
            onClose={closePopup}
            arrow={false}
            trigger={
              <div className="rotate-90">
                <DotsThree weight="bold" />
              </div>
            }
            position="bottom right"
            on="click"
            closeOnDocumentClick
            className="p-0"
            closeOnEscape>
            <div className="shadow-xs flex flex-col rounded-md border bg-main-light">
              {popupOptions.map((opt, idx) => (
                <div
                  key={idx}
                  className={`cursor-pointer px-4 py-2 hover:bg-main-200 ${
                    idx === 0 ? "rounded-t-md"
                    : idx === popupOptions.length - 1 ? "rounded-b-md"
                    : ""
                  }`}
                  onClick={() => {
                    closePopup()
                    opt.onClick()
                  }}>
                  {opt.text}
                </div>
              ))}
            </div>
          </Popup>
        )}
      </div>
    </Button>
  )
}
